import Intercom from './intercom';

export default Intercom;
